'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'calendar-days';
var width = 448;
var height = 512;
var aliases = ["calendar-alt"];
var unicode = 'f073';
var svgPathData = 'M128 8l0-8-16 0 0 64-112 0 0 416 448 0 0-416-112 0 0-64-16 0 0 64-192 0 0-56zM112 80l0 32 16 0 0-32 192 0 0 32 16 0 0-32 96 0 0 96-416 0 0-96 96 0zM304 192l128 0 0 80-128 0 0-80zm-16 0l0 80-128 0 0-80 128 0zm-144 0l0 80-128 0 0-80 128 0zM16 288l128 0 0 80-128 0 0-80zm0 96l128 0 0 80-128 0 0-80zm144 80l0-80 128 0 0 80-128 0zm144 0l0-80 128 0 0 80-128 0zm128-96l-128 0 0-80 128 0 0 80zm-144 0l-128 0 0-80 128 0 0 80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendarDays = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;